module.exports = __webpack_public_path__ + "media/images/digivent/avatars/AVATAR-16-96eeb8877b9353633c7075f296daecad.png";